import { render, staticRenderFns } from "./examOptDrawer.vue?vue&type=template&id=8d0f1156&"
import script from "./examOptDrawer.vue?vue&type=script&lang=js&"
export * from "./examOptDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports